import { Command, CommandResult } from '@/_core/cqrs/types/commands';

export class DeleteWsMemberJiraAuthToken extends Command<CommandResult> {
    constructor() {
        super('DeleteWsMemberJiraAuthToken');
    }
}

export class DismissQuickTip extends Command<CommandResult> {
    constructor(public DismissKey: string) {
        super('DismissQuickTip');
    }
}

export class TrackCountOfAction extends Command<CommandResult> {
    constructor(public Key: string) {
        super('TrackCountOfAction');
    }
}
